export default __webpack_public_path__ + "static/media/love.d51d6163.png";